(function () {
  'use strict';

  function attachSheetToNav(sheet) {
    var navSection = document.querySelector('.tt-nav-section');
    if (!navSection || !sheet || sheet.parentElement === navSection) return;
    navSection.appendChild(sheet);
  }

  function initSearch(root) {
    var toggle = root.querySelector('[data-tt-hdr-search-toggle]');
    var sheet = document.querySelector('[data-tt-hdr-search-sheet]');
    var sheetInput = sheet ? sheet.querySelector('[data-tt-hdr-search-sheet-input]') : null;
    var sheetClose = sheet ? sheet.querySelector('[data-tt-hdr-search-close]') : null;

    if (!toggle || !sheet) return;

    attachSheetToNav(sheet);

    function setSheetOpen(open) {
      if (open) {
        attachSheetToNav(sheet);
        sheet.hidden = false;
        sheet.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('tt-hdr-search-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            sheet.classList.add('is-open');
            if (sheetInput) sheetInput.focus();
          });
        });
      } else {
        sheet.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('tt-hdr-search-open');
        sheet.setAttribute('aria-hidden', 'true');
        if (sheetInput) sheetInput.blur();
        window.setTimeout(function () {
          if (!sheet.classList.contains('is-open')) {
            sheet.hidden = true;
          }
        }, 420);
      }
    }

    root.open = function () {
      setSheetOpen(true);
    };

    root.close = function (focusToggle) {
      setSheetOpen(false);
      if (focusToggle) toggle.focus();
    };

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!sheet.classList.contains('is-open')) {
        setSheetOpen(true);
        return;
      }

      if (sheetInput && sheetInput.value.trim()) {
        sheetInput.form.requestSubmit();
      } else {
        setSheetOpen(false);
        toggle.focus();
      }
    });

    if (sheetClose) {
      sheetClose.addEventListener('click', function () {
        setSheetOpen(false);
        toggle.focus();
      });
    }

    if (sheetInput) {
      sheetInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          setSheetOpen(false);
          toggle.focus();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!sheet.classList.contains('is-open')) return;
      if (sheet.contains(e.target) || root.contains(e.target)) return;
      setSheetOpen(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-tt-hdr-search]').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
